import { Pipe, PipeTransform } from '@angular/core';

import { ReportTypes } from '@mode/shared/contract-common';

@Pipe({
  standalone: true,
  name: 'filterSearch',
})
export class FilterSearchPipe implements PipeTransform {
  private _hasMatch(str: string, filter: string): boolean {
    if (!str || !filter) {
      return false;
    }

    return str.toLowerCase().indexOf(filter.toLowerCase()) !== -1;
  }

  private _getFilteredItems(items: ReportTypes.ReportFilterFieldTypes[], filter: string) {
    return items.filter((item: ReportTypes.ReportFilterFieldTypes) => {
      if (item.type === ReportTypes.ReportFilterFieldType.Folder) {
        let isMatch = false;
        // Return `true` if ANY nested field matches filter
        item.fields.filter((item: ReportTypes.ReportFilterField) => {
          if (this._hasMatch(item.name, filter)) isMatch = true;
        });
        return isMatch;
      } else if (item.type === ReportTypes.ReportFilterFieldType.Field) {
        return this._hasMatch(item.name, filter);
      } else {
        // Fallback
        return true;
      }
    });
  }

  transform(items: ReportTypes.ReportFilterFieldTypes[], filter: string): ReportTypes.ReportFilterFieldTypes[] {
    if (!items || !filter) {
      return items;
    }
    return this._getFilteredItems(items, filter);
  }
}
